import { useEffect, useRef } from 'preact/hooks';

function hasTrackingMethod(method) {
  return typeof method === 'function';
}

export function useSearchResultTracking(controller, result) {
  const elementRef = useRef(null);
  const hasRenderedRef = useRef(false);
  const hasImpressionRef = useRef(false);

  useEffect(() => {
    if (!hasRenderedRef.current && hasTrackingMethod(controller?.track?.product?.render)) {
      controller.track.product.render(result);
      hasRenderedRef.current = true;
    }
  }, [controller, result]);

  useEffect(() => {
    const node = elementRef.current;
    if (!node || hasImpressionRef.current || typeof IntersectionObserver === 'undefined') {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (!entry?.isIntersecting || hasImpressionRef.current) return;

        if (hasTrackingMethod(controller?.track?.product?.impression)) {
          controller.track.product.impression(result);
        }

        hasImpressionRef.current = true;
        observer.disconnect();
      },
      {
        threshold: 0.5,
      }
    );

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [controller, result]);

  return elementRef;
}
